import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { SuspensionDetailModel } from 'src/app/models/rental/suspension-detail.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SuspensionDetailService {

  constructor(private _httpClient: HttpClient) { }

  createSomeDetails(suspensionDetails: Array<SuspensionDetailModel>, suspensionId: number): Observable<boolean> {
    return this._httpClient.post<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.suspensionDetail.CreateSomeDetails}/${suspensionId}`,
      suspensionDetails);
  }

  deleteSomeDetails(suspensionDetailIds: Array<number>, suspensionId: number): Observable<boolean> {
    return this._httpClient.put<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.suspensionDetail.DeleteSomeDetails}/${suspensionId}`,
      suspensionDetailIds);
  }

  exportDetailConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString());
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.suspensionDetail.ExportDetailConsultation}`, filters, {
      params,
      responseType: 'blob'
    });
  }

  getAllSuspensionDetailsWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.suspensionDetail.GetAllSuspensionDetailsWithPagination}`,
      filters, { params: params });
  }

  getColumnsForDetailCapture(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.suspensionDetail.GetColumnsForDetailCapture}`);
  }

  getColumnsForDetailConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.suspensionDetail.GetColumnsForDetailConsultation}`);
  }

  getColumnsForStocksInCostCenter(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.suspensionDetail.GetColumnsForStocksInCostCenter}`);
  }

  getStocksInCostCenterForSuspensionId(page: number, limit: number, columnSort: string | null, ascendant: boolean, suspensionId: number, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant).set('suspensionId', suspensionId);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.suspensionDetail.GetStocksInCostCenterForSuspensionId}`,
      filters, { params: params });
  }

  getSuspensionDetailByKeys(suspensionId: number, articleId: number, storeId: number): Observable<SuspensionDetailModel> {
    const params = new HttpParams().set('suspensionId', suspensionId).set('articleId', articleId).set('storeId', storeId);
    return this._httpClient.get<SuspensionDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.suspensionDetail.GetSuspensionDetailByKeysAsync}`,
      { params: params });
  }

  getSuspensionDetailById(suspensionDetailId: number): Observable<SuspensionDetailModel> {
    return this._httpClient.get<SuspensionDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.suspensionDetail.GetSuspensionDetailById}/${suspensionDetailId}`);
  }

  getSuspensionDetailBySuspensionId(suspensionId: number): Observable<Array<SuspensionDetailModel>> {
    return this._httpClient.get<Array<SuspensionDetailModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.suspensionDetail.GetSuspensionDetailBySuspensionId}/${suspensionId}`);
  }

  getSuspensionDetailsBySuspension(page: number, limit: number, columnSort: string | null, ascendant: boolean, suspensionId: number): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant).set('suspensionId', suspensionId);
    return this._httpClient.get<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.suspensionDetail.GetSuspensionDetailsBySuspension}`,
      { params });
  }

  updateSuspensionDetail(suspensionDetailContractModel: SuspensionDetailModel): Observable<SuspensionDetailModel> {
    return this._httpClient.put<SuspensionDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.suspensionDetail.UpdateSuspensionDetail}`,
      suspensionDetailContractModel);
  }
}
